(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-proof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-proof-carousel')) {
  customElements.define('sb-proof-carousel', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.events) return;
        this.track = this.querySelector('[data-sbpr-track]');
        if (!this.track) return;
        this.cards = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-sbpr-dot]'));
        this.prev = this.querySelector('[data-sbpr-prev]');
        this.next = this.querySelector('[data-sbpr-next]');
        this.nav = this.querySelector('.sbpr__nav');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
        this.prev?.addEventListener('click', () => this.go(this.index - 1), options);
        this.next?.addEventListener('click', () => this.go(this.index + 1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          const directions = { ArrowLeft: -1, ArrowRight: 1 };
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key in directions || event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.positions.length - 1 : this.index + directions[event.key]);
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.sbpr__rev');
          if (!card || !this.contains(card)) return;
          const left = Math.min(card.offsetLeft - this.cards[0].offsetLeft, this.track.scrollWidth - this.track.clientWidth);
          this.go(this.positions.findIndex(position => Math.abs(position - left) < 3), true);
        }, options);
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this.track);
        this.measure();
      });
    }

    measure() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.positions = [];
      this.cards.forEach(card => {
        const left = Math.min(max, Math.max(0, card.offsetLeft - this.cards[0].offsetLeft));
        // Only expose distinct, reachable snap positions (two on wide screens).
        if (!this.positions.length || left - this.positions[this.positions.length - 1] > 2) this.positions.push(left);
      });
      this.dots.forEach((dot, index) => { dot.hidden = index >= this.positions.length; });
      if (this.nav) this.nav.hidden = this.positions.length < 2;
      this.sync();
    }

    sync() {
      this.index = this.positions.reduce((nearest, left, index) => Math.abs(left - this.track.scrollLeft) < Math.abs(this.positions[nearest] - this.track.scrollLeft) ? index : nearest, 0);
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }

    go(index, instant = false) {
      const target = Math.max(0, Math.min(this.positions.length - 1, index));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.positions[target], behavior: instant || reduced ? 'instant' : 'smooth' });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
